import React, { useEffect, useState } from 'react'
import { ChakraProvider, Box, Container, Heading, Text, VStack } from '@chakra-ui/react'
import config from '../../config/config'
import ChristmasDinner2026Form from '../../components/christmas-dinner-2026-form/ChristmasDinner2026Form'
import { getServerTimestamp } from '../../services/firebaseService'

const ChristmasDinner2026FormPage: React.FC = () => {
  const [isAvailable, setIsAvailable] = useState<boolean>(false)
  const [isCheckingTime, setIsCheckingTime] = useState<boolean>(true)

  useEffect(() => {
    const checkAvailability = async (): Promise<void> => {
      // Verificar primero si está habilitado en la configuración
      if (!config.CHRISTMAS_DINNER_2026_AVAILABLE) {
        setIsAvailable(false)
        setIsCheckingTime(false)
        return
      }

      // Obtener la fecha del servidor
      const serverTimeResponse = await getServerTimestamp()

      if (serverTimeResponse.success && serverTimeResponse.data != null) {
        const serverDate = serverTimeResponse.data
        const deactivationDate = new Date(config.FORM_CHRISTMAS_DINNER_2026_DEACTIVATION_DATE)

        // El formulario está disponible si no se ha pasado la fecha de desactivación
        const available = serverDate < deactivationDate
        setIsAvailable(available)
      } else {
        // Si no se puede obtener la fecha del servidor, desactivar por seguridad
        setIsAvailable(false)
      }

      setIsCheckingTime(false)
    }

    void checkAvailability()
  }, [])

  return (
    <ChakraProvider>
      {isCheckingTime && <></>}
      {!isCheckingTime && isAvailable && <ChristmasDinner2026Form/>}
      {!isCheckingTime && !isAvailable && (
        <Container maxW="container.md" py={20}>
          <VStack spacing={6} textAlign="center">
            <Box>
              <Heading as="h1" size="xl" mb={4} color="red.600">
                Prazo de inscrición rematado
              </Heading>
              <Text fontSize="lg" color="gray.600">
                Sentímolo moito, pero o prazo para inscribirse na Cea de Nadal 2026 xa rematou.
              </Text>
              <Text fontSize="md" color="gray.500" mt={4}>
                Para máis información, podes contactar con nós en{' '}
                <Text as="span" color="blue.600" fontWeight="bold">
                  {config.EMAIL}
                </Text>
              </Text>
            </Box>
          </VStack>
        </Container>
      )}
    </ChakraProvider>
  )
}

export default ChristmasDinner2026FormPage
